export const getDumpFromQuery = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  return new URLSearchParams(window.location.search).get('dump') === 'true'
}
